import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThailand = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0052b4",
			d: "M496 167H16a255.4 255.4 0 0 0 0 178h480a255.4 255.4 0 0 0 0-178z"
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#d80027",
			children: /* @__PURE__ */ _jsx("path", { d: "M256 0A255.4 255.4 0 0 0 62 89h388C403.2 34.5 333.7 0 256 0zM450 423H62c46.9 54.5 116.4 89 194 89s147.1-34.5 194-89z" })
		})
	]
});
export default SvgThailand;
